"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconCreateValue = function SvgIconCreateValue(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "create value icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Create Value Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.56 11.062a1.5 1.5 0 11-2.12-2.123l1.5-1.5a1.5 1.5 0 112.12 2.123l-1.5 1.5zm.44 3.44a1.5 1.5 0 000 3h1.5a1.5 1.5 0 000-3H36zm-9.75 13.124h-4.5a1.125 1.125 0 000 2.25h4.5a1.125 1.125 0 000-2.25zM10.5 17.501H12a1.5 1.5 0 000-3h-1.5a1.5 1.5 0 000 3zm4.061-6.44a1.5 1.5 0 01-2.121 0l-1.5-1.5a1.5 1.5 0 012.12-2.122l1.5 1.5a1.5 1.5 0 01.001 2.122zm20.379 13.5a1.5 1.5 0 102.12-2.122l-1.5-1.5a1.5 1.5 0 10-2.12 2.123l1.5 1.5zm-24-2.122l1.5-1.5a1.5 1.5 0 112.12 2.123l-1.5 1.5a1.5 1.5 0 11-2.12-2.123zm21.31-6.438a8.25 8.25 0 10-12.195 7.215c.12.066.195.193.195.33v.705a1.5 1.5 0 001.5 1.5h4.5a1.5 1.5 0 001.5-1.5v-.705c0-.137.075-.264.195-.33a8.25 8.25 0 004.305-7.215zM17.645 31.104a.75.75 0 01.355.572l.75 8.256a.75.75 0 01-.75.82H6.75a.75.75 0 01-.75-.75 6.781 6.781 0 014.374-6.326l6.6-2.628a.75.75 0 01.67.056zm19.985 2.58l-6.6-2.63a.75.75 0 00-1.03.622l-.75 8.25a.75.75 0 00.75.82h11.25a.75.75 0 00.75-.75 6.796 6.796 0 00-4.37-6.311zM24 33.67a.78.78 0 01.696.428l2.25 5.625a.75.75 0 01-.696 1.03h-4.5a.75.75 0 01-.696-1.03l2.25-5.625A.78.78 0 0124 33.67z"
  }));
};

var _default = SvgIconCreateValue;
exports.default = _default;